import { render, staticRenderFns } from "./BlockOptions.vue?vue&type=template&id=0819262a&scoped=true"
import script from "./BlockOptions.vue?vue&type=script&lang=js"
export * from "./BlockOptions.vue?vue&type=script&lang=js"
import style0 from "./BlockOptions.vue?vue&type=style&index=0&id=0819262a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0819262a",
  null
  
)

export default component.exports